module.exports = __webpack_public_path__ + "img/2-4.7ffdafb0.svg";